<template>
  <div class="page height-full">
    <app-header title="Campaigns"/>
    <div class="container-fluid" v-if="isLoading">
      <spinner style="margin-top: 25%"></spinner>
    </div>
    <div v-if="isLoading == false">
      <b-card class="page height-full">
        <b-row>
          <div class="col-md-12">
            <div class="p-3">
              <div>
                <b-table striped hover :items="items"></b-table>
              </div>
            </div>
          </div>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
  import axios from "axios"
  import Constants from "../../Constants"
  import Spinner from '../common/Spinner'

  String.prototype.toProperCase = function() {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  };

  export default {
    name: "Campaigns",
    components: {
      Spinner
    },
    data: () => ({
      isLoading: false,
      isLoadingLists: false,
      showMobileCampaign: false,
      campaigns: [],
      selected: {
        message: '',
        status: '',
        recipients: []
      },
      form: {
        name: "",
        message: "",
        selected: [],
      },
      options: [{value: 'ALL', text: 'All'}],
      items: [
          { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
          { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
          { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
          { age: 38, first_name: 'Jami', last_name: 'Carney' }
        ]
    }),
    computed: {
      getNumberSubscribers() {
        if (this.form.selected.length > 0)
          if (this.form.selected[0] === "ALL")
            return "all"
        return this.form.selected.length
      }, 
      showEmptyCampaignMessage() {
        console.log(this.campaigns.length)
        return this.isLoading == false && this.campaigns.length == 0
      },
      showCampaignDetail() {
        return this.campaigns.length > 0
      }
    },
    methods: {
      getCampaigns() {
        this.isLoading = true
        axios
          .get(Constants.API_URL + "/campaigns")
          .then(response => {
            console.log(response);
            this.campaigns = response.data.Items
            if (this.campaigns.length > 0)
              this.changeSelected(this.campaigns[0])
          }).catch((err) => {
            if (err.response.status == 401) {
              window.location.href = "/campaigns"
            }
          }).then(() => {
            this.isLoading = false
          })
      },
      getLists() {
        this.isLoadingLists = true
        axios
          .get(Constants.API_URL + "/lists")
          .then(response => {
            response.data.Items.forEach((item) => {
              this.options.push({value: item.sk.split('|')[1], text: item.name});
            })
          }).catch((err) => {
            console.log(err)
          }).then(() => {
          this.isLoadingLists = false
        })
      },
      changeSelected(campaign) {
        this.selected = campaign
        if (document.documentElement.clientWidth < 992) {
          this.showMobileCampaign = true 
        }
      },
      getRecipientsList(recipients) {
        if (recipients === undefined) return ""

        if (recipients.length > 0) {
          return recipients.join(", ")  
        } else {
          return ""
        }      
      },
      newCampaign() {
        this.$router.push('/campaigns/new')
      },
      getRecipients(recipients) {
        if (recipients === undefined) return ""
        if (recipients.length == 0) return ""

        const tmp = recipients.split(",")
        let result = ""
        tmp.forEach((item) => {
          result += (Constants.FORMAT_PHONE_NUMBER(item) + "<br>")
        })
        return result
      },
      reset() {
        this.form.name = "";
        this.form.message = "";
        this.form.selected = [];
      },
      close() {
        this.reset();
      },
      previewMessage() {
        if (this.form.selected.length > 0 && this.form.name !== '' && this.form.message !== '') {
        } else {
          this.$swal('', 'You need to enter all data first', 'warning');
        }
      },
      send() {
        const params = {
          name: this.form.name,
          message: this.form.message,
          recipientsLists: this.form.selected,
        }
        this.isLoading = true
        axios
          .post(Constants.API_URL + "/campaigns", params)
          .then(response => {
            console.log(response);
            this.isLoading = false
            this.close()
          })
          .finally(() => {
            this.getCampaigns()
          }).catch(() => {
          this.isLoading = false
        })
      }
    },
    mounted() {
      this.getCampaigns()
      this.getLists()
    }
  }
</script>

<style scoped>
  .dialog-content {
    max-height: 600px;
    width: 100%;
  }

  .md-dialog-container {
    width: 50%;
  }

  .card-height {
    min-height: 600px;
  }

  .selected {
    background-color: #F5F8FA;
  }
</style>



// WEBPACK FOOTER //
// src/components/campaigns/Campaigns.vue